import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetFacetsFromPreselectedFiltersMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.setFacetsFromPreselectedFilters]: (searchState: SearchState) => {
      searchState.facets = searchState.preSelectedFilters;
    }
  };
}
